import React from "react";
import PageContainerAuth from "../../components/common/PageContainerAuth";

export function Healthcheck() {

    return (
        <PageContainerAuth section="system-healthcheck" pageTitle="Healthcheck">
            <h1>Healthcheck</h1>
        </PageContainerAuth>
    );
}